import { render, staticRenderFns } from "./companyAttr.vue?vue&type=template&id=5b2b42ac&scoped=true&"
import script from "./companyAttr.vue?vue&type=script&lang=js&"
export * from "./companyAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2b42ac",
  null
  
)

export default component.exports